export default "__VITE_ASSET__yTiMFFqg__"